module.exports = __webpack_public_path__ + "img/CRT_WF_Weapon-Sword-2.b248d7c4.png";